import { render, staticRenderFns } from "./ph-rules.vue?vue&type=template&id=f667b970&scoped=true"
import script from "./ph-rules.vue?vue&type=script&lang=js"
export * from "./ph-rules.vue?vue&type=script&lang=js"
import style0 from "./ph-rules.vue?vue&type=style&index=0&id=f667b970&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f667b970",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f667b970')) {
      api.createRecord('f667b970', component.options)
    } else {
      api.reload('f667b970', component.options)
    }
    module.hot.accept("./ph-rules.vue?vue&type=template&id=f667b970&scoped=true", function () {
      api.rerender('f667b970', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/help/help-rules/ph-rules.vue"
export default component.exports